import { request } from 'js/api/axios';

// How often to ask the database about an attempt the channel has not
// settled. The channel is the fast path; this only catches what it missed.
export const GENERATION_RECORD_POLL_MS = 20000;

/**
 * Asks for one attempt's durable record until it is complete or failed, then
 * calls onSettled with it once. Returns a function that stops asking.
 */
export function watchGenerationRecord({ basePath, headers, nonce, onSettled }) {
  let stopped = false;

  const check = async () => {
    try {
      const resp = await request.get(`${basePath}/generations/${nonce}`, {
        headers,
      });
      const record = resp.data?.data;
      if (!stopped && record && record.status !== 'running') {
        stopped = true;
        clearInterval(timer);
        onSettled(record);
      }
    } catch {
      // Not recorded (yet), or a blip: ask again next time.
    }
  };

  const timer = setInterval(check, GENERATION_RECORD_POLL_MS);

  return () => {
    stopped = true;
    clearInterval(timer);
  };
}
